export default __webpack_public_path__ + "static/awards-pc-co-84ac7eb6072fbab37754651bcacf61be.png";